<script setup lang="ts">
import WifiOffIcon from '@/assets/icons/wifi-off.svg';
import { useConnectivity } from '@/composables/useConnectivity';

const { isOnline } = useConnectivity();
</script>

<template>
  <Transition name="network-banner">
    <div
      v-if="!isOnline"
      class="fixed left-0 right-0 z-[9999] flex items-center justify-center gap-2 bg-warning-primary px-4 py-2"
      :style="{ top: 'env(safe-area-inset-top, 0px)' }"
    >
      <WifiOffIcon class="h-4 w-4 fill-current text-warning-primary" />
      <span class="text-sm font-medium text-warning-primary">Pas de connexion internet</span>
    </div>
  </Transition>
</template>

<style scoped>
.network-banner-enter-active,
.network-banner-leave-active {
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.network-banner-enter-from,
.network-banner-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
